export default __webpack_public_path__ + "static/life-grid-orange-yellow-min-4b66e4c1473a23653743cfeb9dfa48d7.png";